/**
 * /signup — the standalone account form.
 *
 * Outside the shell, like /login, and on the same .hd-auth column: it is a form
 * and nothing else, and a sidebar has nothing to offer somebody with no account
 * yet.
 *
 * Renders the SAME SignUpForm the tournament modal does. The two entry points
 * differ only in what they know — this one has no tournament behind it, so the
 * new account lands on a bare /profile with no banner. Normal, not a fallback.
 */

import { Link, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import SignUpForm from '../components/auth/SignUpForm.jsx';

export default function SignUp() {
  const { isAuthenticated, isLoading } = useAuth();

  // Nothing here is useful to somebody already holding a session, and
  // submitting it would only ever produce the duplicate-email 409.
  if (!isLoading && isAuthenticated) return <Navigate to="/profile" replace />;

  return (
    <div className="hd-auth">
      <div className="hd-auth-inner hd-stack">
        <div>
          <div
            className="hd-brand"
            style={{ padding: 0, fontSize: 22, marginBottom: 4 }}
          >
            HOPDARTS
          </div>
          <p className="hd-meta">Create your player account.</p>
        </div>

        <SignUpForm />

        <p className="hd-hint">
          Already have an account? <Link to="/login">Sign in</Link>.
        </p>
      </div>
    </div>
  );
}
